import { useQuery } from '@tanstack/react-query';
import { authClient } from '@/lib/auth-client';

const API_BASE = (import.meta.env.VITE_API_URL ?? 'http://localhost:3000').replace(/\/+$/, '');

export const PHOTO_URL = `${API_BASE}/api/v1/me/profile/photo`;

/** The signed-in person's picture as a local URL, or null when they have none. */
export function useProfilePhoto(): string | null {
  const { data: session } = authClient.useSession();
  const photo = useQuery({
    queryKey: ['profile-photo', session?.user.id ?? ''],
    enabled: Boolean(session),
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const response = await fetch(PHOTO_URL, { credentials: 'include' });
      if (!response.ok) return null;
      return URL.createObjectURL(await response.blob());
    },
  });
  return photo.data ?? null;
}
